import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {Proposal} from '../../../model/proposal/proposal';
import {OfferService} from '../../../services/offer/offer.service';
import {map, Observable} from 'rxjs';
import {ProposalSlip} from '../../../model/proposal-slip';

@Component({
    selector: 'app-proposal-slip-tab',
    templateUrl: './proposal-slip-tab.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ProposalSlipTabComponent {
  @Input() set proposal(proposal: Proposal) {
    let offers$ = this.offerService.getOffersForSlip(proposal.proposalInformation.id);
    this.proposalSlip$ = offers$.pipe(map(offers => {
      const proposalSlip = new ProposalSlip(proposal);
      proposalSlip.offers = offers;
      return proposalSlip;
    }));
  }

  proposalSlip$: Observable<ProposalSlip>;

  constructor(private readonly offerService: OfferService) {
  }


}
